module.exports = __webpack_public_path__ + "static/media/starbucks.d32e08ef.jpg";